import { mapActions } from 'vuex';
import { STATIC_PAGES } from '@/constants';
import cmsContentMixin from '@/mixins/cmsContent';

export default {
  mixins: [
    cmsContentMixin,
  ],
  metaInfo() {
    return {
      title: 'Platform Announcements',
    };
  },
  methods: {
    ...mapActions('browse', ['getStaticPageFull']),
  },
  created() {
    this.getStaticPageFull(STATIC_PAGES.PLATFORM_ANNOUNCEMENTS)
      .then((data) => {
        this.installDynamicControls({ data });
      });
  },
};



// WEBPACK FOOTER //
// ./src/components/pages/page-platform-announcements/page-platform-announcements.js